// The four fixed capture stations, plus the mid-motion frame.
//
// These are contractual. The harness captures exactly these every round, so moving one invalidates
// comparison against every previous round's shots. If a station has to move, say so in LOG.md and
// treat the next round as a new baseline.

import { WORLD, WALKWAY_Y } from './config.js';

/**
 * Each station: where the eye is, what it looks at, and what the round is meant to be JUDGING.
 * `judges` is not used by the renderer -- it goes into the critic prompt so the tell lands on the
 * right system.
 */
export const STATIONS = [
  {
    id: 1,
    name: 'street',
    label: 'Main street, west sidewalk, looking north',
    pos: [-6.4, WORLD.EYE_H + WORLD.KERB_H, -26.0],
    look: [0.8, 3.4, 12.0],
    judges: 'street cross-section, building massing and height variety, depth of the corridor, how much clutter hangs over the roadway',
  },
  {
    id: 2,
    name: 'alley',
    label: 'West alley mouth, looking west into the alley',
    pos: [-8.6, WORLD.EYE_H + WORLD.KERB_H, -10.2],
    look: [-26.0, 2.2, -10.4],
    judges: 'alley width vs building height, service clutter density, the steel stair, drainage and ground detail',
  },
  {
    id: 3,
    name: 'arcade',
    label: 'Inside the covered arcade, looking east (deeper in)',
    pos: [12.4, WORLD.EYE_H + 0.02, -20.2],
    look: [25.0, 1.9, -20.4],
    judges: 'ceiling height and structure, shopfront rhythm, how a covered interior space reads vs the open street',
  },
  {
    id: 4,
    name: 'walkway',
    label: 'Elevated walkway, looking back down over the street',
    pos: [-7.05, WALKWAY_Y + WORLD.EYE_H, -4.0],
    look: [2.5, 0.6, 20.0],
    judges: 'roofline silhouettes, the street read from above, sign-bracket and cable density across the gap, walkway railing and structure',
  },
];

/**
 * The mid-motion frame. Not a static station -- the harness walks the player along this path and
 * grabs the frame at `atT`, so head-bob and stride phase are in the picture.
 */
export const MOTION = {
  id: 5,
  name: 'motion',
  label: 'Walking north on the east sidewalk',
  from: [5.9, 0, -14.0],
  to: [5.9, 0, 8.0],
  yaw: Math.PI,          // facing +Z (north, down the street)
  atT: 3.2,              // seconds into the walk
  judges: 'whether a moving frame reads as handheld footage -- head motion, motion cue, framing',
};

export function stationById(id) {
  return STATIONS.find((s) => s.id === id) || null;
}
